import { MeasuredValue, defaultMeasurementState } from './types';
import {
  createListenerMiddleware,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { FileParameter, ReadFileData } from '@lmt/shared-types';

// we need to preserve _measurementState when user logs in to fix #63543: MSV importer not opening
let _measurementState = defaultMeasurementState();

export const measurementSlice = createSlice({
  name: 'measurement',
  initialState: () => _measurementState,

  reducers: {
    measuredValuesLoaded(state, action: PayloadAction<MeasuredValue[]>) {
      return {
        ...state,
        measuredValues: action.payload,
      };
    },
    importFinished(state, action: PayloadAction) {
      return {
        ...state,
        measuredValues: [],
        readFile: undefined,
      };
    },
    importRestarted(state, action: PayloadAction) {
      return {
        ...state,
        measuredValues: [],
      };
    },
    importCancelled(state, action: PayloadAction) {
      return {
        ...state,
        measuredValues: [],
        readFile: undefined,
        file: undefined,
        pdfFile: undefined,
      };
    },
    fileRead(state, action: PayloadAction<ReadFileData>) {
      return {
        ...state,
        readFile: action.payload,
      };
    },
    fileLoaded(state, action: PayloadAction<FileParameter>) {
      return {
        ...state,
        file: action.payload
          ? {
              fileName: action.payload.fileName,
              data: action.payload.data,
            }
          : undefined,
      };
    },
    pdfFileLoaded(state, action: PayloadAction<FileParameter | null>) {
      return {
        ...state,
        pdfFile: action.payload
          ? {
              fileName: action.payload.fileName,
              data: action.payload.data,
            }
          : null,
      };
    },
  },
});

export const MeasurementActions = measurementSlice.actions;

// we need to preserve MeasurementState when user logs in to fix #63543: MSV importer not opening
export const measurementListenerMiddleware = createListenerMiddleware();
measurementListenerMiddleware.startListening({
  predicate(action) {
    return action.type.startsWith('measurement');
  },
  effect: async (action, listenerApi) => {
    _measurementState = (listenerApi.getState() as any).measurement;
  },
});
